__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)